
import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Box, Link } from '@mui/material';
import { jaJP } from '@mui/x-data-grid'
import { useAuth } from './../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { fileURL } from './../../apis/ApiConfig';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import ReaOnlyOutlinedInput from '../../components/input/ReaOnlyOutlinedInput'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import NumPad from '../../components/uiParts/NumPad'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput'
import CustomSelect from '../../components/select/CustomSelect'
//import { bidUnitList } from '../../Store'
import { normarize } from '../../utils/Library'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from "@mui/icons-material/Close";

const BidRegister = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const userName       = authInfo.userName
    const authority      = authInfo.authority
    const traderCode     = authInfo.traderCode
    const trader         = authInfo.trader
    const today          = authInfo.targetDate
    
    const search    = useLocation().search
    const query     = new URLSearchParams(search)
    const initialId = query.get('bidGroupNo')

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ contentsHeight,      setContentsHeight      ] = useState(window.innerHeight -100)
    const [ dataGridHeight,      setDataGridHeight      ] = useState(window.innerHeight -460)
    const [ containerHeight,     setContainerHeight     ] = useState(window.innerHeight -100)
    const [ dataGridWidth,       setDataGridWidth       ] = useState(window.innerWidth -460)
    const [ searchCount,         setSearchCount         ] = useState(0)
    const [ bidList,             setBidList             ] = useState([])
    const [ bidHistoryList,      setBidHistoryList      ] = useState([])
    const [ commentList,         setCommentList         ] = useState([])
    const [ requireMessage,      setRequireMessage      ] = useState('')
    const [ registerMessage,     setRegisterMessage     ] = useState('')
    const [ cancelMessage,       setCancelMessage       ] = useState('')
    const [ noBidMessage,        setNoBidMessage        ] = useState('')
    const [ focusCell,           setFocusCell           ] = useState('')
    const [ bidUnitList,         setBidUnitList         ] = useState([])
    const [ maxPrice,            setMaxPrice            ] = useState('')
    const [ unitName,            setUnitName            ] = useState('Kg')
    const [ openDialogImageFile, setOpenDialogImageFile ] = useState(false);
    const [ imagePreview,        setImagePreview        ] = useState({ url: "", title: "" });
    
    // BidGroupデータ
    const [ bidGroupData, setBidGroupData ] = useState({
        entryNo    : '',
        bidName    : '',
        kgSuryo    : '',
        suryo      : '',
        kgKubun    : '',
        gyoshuCode : '',
        nisugata   : '',
        kikakuCode : '',
        danbe      : '',
    })
    // 登録データ
    const [ registerData, setRegisterData ] = useState({
        facilityCode  : facilityCode,
        userId        : userId,
        activeFlag    : 1,
        userId        : userId,
        bidGroupNo    : initialId,
        traderCode    : traderCode,
        trader        : trader,
        entryUserId   : userId,
        entryUser     : userName,
        seq           : '',
        ip            : '',
        entrySuryo    : 0,
        entryUnit     : 1,
        tanka         : '',
        conditionCode : '',
        condition     : '',
        bidStatus     : 0,
    })
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue         : false,
        snackBarFalse        : false,
        require              : false,
        confirm              : false,
        confirm_register     : false,
        confirm_price_before : false,
        confirm_price_after  : false,
        confirm_noBid        : false,
    })
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const tankaRef      = useRef()
    const entrySuryoRef = useRef()
    const entryUnitRef  = useRef()
    const conditionRef  = useRef()
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getData / BidGroup
	//-----------------------------------------------
    const { response : getData_res, loading : getData_Loading, post:getData_post } = usePost()
    const getData = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : initialId
        }
        await getData_post(postData)
    }
	//-----------------------------------------------
    // API - getDataInGroup / BidList
	//-----------------------------------------------
    const { response : getDataInGroup_res, loading : getDataInGroup_Loading, post:getDataInGroup_post } = usePost()
    const getDataInGroup = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : isRebid() ? initialId.split(".")[0] : initialId,
            'bidGroupNoOrg' : initialId,
        }
        await getDataInGroup_post(postData)
    }
	//-----------------------------------------------
    // API - getNextNo / BidList
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost()
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : initialId,
            'traderCode'   : traderCode
        }
        await getNextNo_post(postData)
    }
    //-----------------------------------------------
    // API - searchData / BidHistory
    //-----------------------------------------------
    const { response : searchData_history_res, loading : searchData_history_Loading, post:searchData_history_post } = usePost()
    const searchData_history = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'searchDataByTrader',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : initialId,
            'traderCode'   : traderCode,
            'entryUserId'  : userId
        }
        await searchData_history_post(postData)
    }
	//-----------------------------------------------
    // API - setData / BidHistory
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost()
    const setData = async (targetData) => {
        if (targetData.entryUnit == 2) {
            targetData.entrySuryo = Math.floor(targetData.entrySuryo)
        }
        const postData = {
            'className'     : 'mch.models.table.BidHistory',
            'methodName'    : 'setDataByTrader',
            'facilityCode'  : facilityCode,
            'userId'        : userId,
            'activeFlag'    : targetData.activeFlag,
            'userId'        : targetData.userId,
            'bidGroupNo'    : targetData.bidGroupNo,
            'seq'           : targetData.seq,
            'traderCode'    : targetData.traderCode,
            'trader'        : targetData.trader,
            'entryUserId'   : targetData.entryUserId,
            'entryUser'     : targetData.entryUser,
            'ip'            : targetData.ip,
            'entrySuryo'    : targetData.entryUnit == 1 ? 0 : targetData.entrySuryo,
            'entryUnit'     : (targetData.entrySuryo == 0 || targetData.entrySuryo == 0.0) ? 1 : targetData.entryUnit,
            'tanka'         : targetData.tanka,
            'conditionCode' : targetData.conditionCode,
            'condition'     : targetData.condition,
            'bidStatus'     : targetData.bidStatus,
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            if (setData_res.statusCode == 9) {
                setRequireMessage('落札済みのため入札できません')
                setMessageInfo('require', true)
            } else if (setData_res.statusCode == 8) {
                setRequireMessage('開票中のため入札できません')
                setMessageInfo('require', true)
            } else if (setData_res.statusCode == 0) {
                setRequireMessage('入札が解除されたため入札できません')
                setMessageInfo('require', true)
            } else {
                setSearchCount(searchCount+1)
                tankaRef.current.focus()
                setFocusCell('tanka')
    
                setMessageInfo('confirm', false)
                setMessageInfo('snackBarTrue', true)
            }
        }
    }, [setData_res])
	//-----------------------------------------------
    // API - searchData / masta.Comment
	//-----------------------------------------------
    const { response : getDataAll_comment_res, post : getDataAll_comment_post } = usePost()
    const getDataAll_comment = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_comment_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.Comment
	//-----------------------------------------------
    const { response : getData_comment_res, post : getData_comment_post } = usePost()
    const getData_comment = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_comment_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)
        
        tankaRef.current.focus()
        setFocusCell('tanka')
        
        const handleResize = () => {
            setContentsHeight(window.innerHeight - 100)
            setDataGridHeight(window.innerHeight - 460)
            setContainerHeight(window.innerHeight - 100)
            setDataGridWidth(window.innerWidth - 460)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        getData()
        getDataInGroup()
        searchData_history()
        getDataAll_comment()
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            seq           : '',
            tanka         : '',
            entrySuryo    : 0,
            entryUnit     : 1,
            conditionCode :'',
        }))
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_res) {
            const maxSuryo = getData_res.kgKubun == 1 ? getData_res.kgSuryo : getData_res.suryo
            setBidGroupData({
                ...getData_res,
                kgSuryo : maxSuryo
            })
            if (bidGroupData.kgKubun == 1) {
                registerData.entryUnit = 2 // Kg
                setUnitName('Kg')
            } else if (bidGroupData.kgKubun == 0) {
                registerData.entryUnit = 4 // 箱
                setUnitName('箱')
            } else if (bidGroupData.kgKubun == 2) {
                registerData.entryUnit = 5 // 本
                setUnitName('本')
            } else if (bidGroupData.kgKubun == 3) {
                registerData.entryUnit = 6 // 匹
                setUnitName('匹')
            } else {
                registerData.entryUnit = 7 // 袋
                setUnitName('袋')
            }
            getData_fishSpec(getData_res.gyoshuCode)
            getData_standard(getData_res.kikakuCode)
        }
    }, [getData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            const targetData = { ...registerData, seq: getNextNo_res.seq }
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData)
                setMessageInfo('confirm_register', false)
                setMessageInfo('confirm_price_before', false)
                setMessageInfo('confirm_price_after', false)
                setMessageInfo('snackBarTrue', true)
                setSearchCount(searchCount+1)
                tankaRef.current.focus()
                setFocusCell('tanka')
            } else {
                setMessageInfo('require', true)
            }
        }
    }, [getNextNo_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([])
        if (getDataInGroup_res) {
            setBidList(getDataInGroup_res.Data)
        }
    }, [getDataInGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / bidHistory)
	//-----------------------------------------------
    useEffect(() => {
        setBidHistoryList([])
        if (searchData_history_res) {
            setBidHistoryList(searchData_history_res.Data)
        }
    }, [searchData_history_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        setCommentList([])
        if (getDataAll_comment_res) {
            getDataAll_comment_res.Data.unshift({id:'0',name:'未選択'});
            setCommentList(getDataAll_comment_res.Data)
        }
    }, [getDataAll_comment_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_comment_res) {
            handleChange('conditionCode', getData_comment_res.code)
            handleChange('condition', getData_comment_res.displayName)
        }
    }, [getData_comment_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res && bidGroupData) {
            
            const array = [{ id: '1', name: '全量' }]
            if (bidGroupData.kgKubun == 1) {
                array.push({ id: '2', name: 'Kg' })
                array.push({ id: '3', name: 'D' })
            } else if (bidGroupData.kgKubun == 0) {
                array.push({ id: '4', name: '箱' })
            } else if (bidGroupData.kgKubun == 2) {
                array.push({ id: '5', name: '本' })
            } else if (bidGroupData.kgKubun == 3) {
                array.push({ id: '6', name: '匹' })
            } else if (bidGroupData.kgKubun == 4) {
                array.push({ id: '7', name: '袋' }) 
            } else {
                array.push({ id: '2', name: 'Kg' })
                array.push({ id: '3', name: 'D' })
            }
            setBidUnitList(array)
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                entryUnit: 1,
            }))
            
            if (getData_fishSpec_res.maxPrice) setMaxPrice(getData_fishSpec_res.maxPrice)
        }
    }, [getData_fishSpec_res, bidGroupData])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        //if (name == 'entrySuryo') value = normarize(value)
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }))
        if (name == 'entryUnit' && value == 1) {
            registerData.entrySuryo = 0
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                entrySuryo: '0',
            }))
        }
    }
	//-----------------------------------------------
    // eventHandler - コメントの変更
	//-----------------------------------------------
    const handleChange_comment = (value) => {
        getData_comment(value)
    }
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const targetData = { ...registerData, activeFlag }
        // 新規の場合はuniqueIdを発行して登録処理を実行
        if (!targetData.seq) {
            await getNextNo()
        
        // 更新の場合は既存のuniqueIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                await setData(targetData)
                setSearchCount(searchCount+1)
                setMessageInfo('confirm', false)
                setMessageInfo('confirm_register', false)
                setMessageInfo('confirm_price_before', false)
                setMessageInfo('confirm_price_after', false)
                setMessageInfo('confirm_noBid', false)
                setMessageInfo('snackBarTrue', true)
            } else {
                setMessageInfo('require', true)
            }
        }
        return false
    }
	//-----------------------------------------------
    // eventHandler - テンキーを操作
	//-----------------------------------------------
    const handleClick_numpad = (item) => {
        let prevVal;
        let targetVal;
        if (item == 'ENTER') {
        } else {
            // Kg数量
            if (focusCell == 'tanka') {
                prevVal = registerData.tanka
                if (prevVal == '0' || prevVal == '00') {
                    prevVal = '';
                }
                targetVal = item == 'C' ? '' : `${ prevVal }${item}`
                handleChange('tanka', targetVal);
            } else if (focusCell == 'entrySuryo') {
                prevVal = registerData.entrySuryo
                if (prevVal == '0' || prevVal == '00') {
                    prevVal = '';
                }
                targetVal = item == 'C' ? '' : `${ prevVal }${item}`
                handleChange('entrySuryo', targetVal);
            }
        }
    }
	//-----------------------------------------------
    // eventHandler - テンキーを操作
	//-----------------------------------------------
    const handleClick_numpad_enter = ()=> {
        if (focusCell == 'tanka') {
            entrySuryoRef.current.focus()
            setFocusCell('entrySuryo')
        } else if (focusCell == 'entrySuryo') {
            const normalizedValue = normarize(registerData.entrySuryo)
            handleChange('entrySuryo', normalizedValue)
            //if (normalizedValue == 0) handleChange('entryUnit', 1)
            entryUnitRef.current.focus()
            setFocusCell('entryUnit')
        } else if (focusCell == 'entryUnit') {
            conditionRef.current.focus()
            setFocusCell('condition')
        } else if (focusCell == 'condition') {
            tankaRef.current.focus()
            setFocusCell('tanka')
        }
    }
	//-----------------------------------------------
    // eventHandler - 新規ボタンのクリック
	//-----------------------------------------------
    const handleClick_new = () => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            seq           : '',
            tanka         : '',
            entrySuryo    : 0,
            entryUnit     : 1,
            conditionCode : '',
        }))
    }
	//-----------------------------------------------
    // eventHandler - 札入なしボタンのクリック
	//-----------------------------------------------
    const handleClick_noBid_before = async () => {
        setNoBidMessage('')
        const noBid = bidHistoryList.some(item => item.bidStatus === 9);
        if (noBid){
            setRequireMessage('すでに「札入なし」の状態です')
            setMessageInfo('require', true)
            return;
        }
        const isState = bidHistoryList.length > 0 
        if(isState){
            setRequireMessage('すでに入札済みです')
            setMessageInfo('require', true)

        } else {
            setNoBidMessage(
                <>
                    「札入なし」にします。<br />
                    よろしいですか？
                </>
            )
            setMessageInfo('confirm_noBid', true)
        }
        
    }
	//-----------------------------------------------
    // eventHandler - 札入なしの処理
	//-----------------------------------------------
    const handleClick_noBid = async () => {

        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            activeFlag    : 1,
            tanka         : -1,
            entrySuryo    : -1,
            entryUnit     : -1,
            bidStatus     : 9,
            conditionCode : '',
        }))
        
        await getNextNo()
        await setData(registerData)
        setMessageInfo('confirm_noBid', false)
        setMessageInfo('snackBarTrue', true)
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            tanka         : "",
            bidStatus     : 0,
        }))
    }   
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - 入札一覧の見出し
	//-----------------------------------------------
    const columns = [
        { field: 'senmei', headerName: '荷主',    width: 150, columnSeparatorWidth: 1, },
        { field: 'displayGyoshu', headerName: '品名',    width: 180, columnSeparatorWidth: 1, },
        { field: 'kgSuryo', headerName: 'Kg数',    width: 80, columnSeparatorWidth: 1, type:'number'},
        { field: 'suryo', headerName: '数量',    width: 80, columnSeparatorWidth: 1, type:'number'},
        {
            field: 'kgKubun',
            headerName: '単位',
            width: 80,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'displayBiko', headerName: '備考',    width: 150, columnSeparatorWidth: 1, sortable:false, },
        {
            field: 'fileName',
            headerName: '写真',
            width: 80,
            columnSeparatorWidth: 1,
            sortable:false,
            renderCell: (params) => {
                const url = params.value;
                if (!url) return "-";
                return (
                    <Link
                        component="button"
                        underline="always"
                        onClick={() => handleClick_fileName(params.row)}
                    >
                        表示
                    </Link>
                );
            }
        },
    ]
    const unitMapping = {
        1: 'Kg',
        0: '箱',
    }
	//-----------------------------------------------
    // dataGrid - 入札状況一覧の見出し
	//-----------------------------------------------
    const columns_history = [
        { field: 'id',        headerName: 'No',      width: 70, columnSeparatorWidth: 1, type:'number'},
        { field: 'trader',    headerName: '仲買人',  width: 150, columnSeparatorWidth: 1, },
        { field: 'entryUser', headerName: '入札ユーザ',  width: 150, columnSeparatorWidth: 1, },
        {
            field: 'tanka',
            headerName: '入札単価',
            width: 110,
            type:'number',
            renderCell: (params) => (
                params.row.bidStatus === 9 ? '札入なし' : `${params.value}円`
            ),
        },
        { field: 'entrySuryo', headerName: '入札数量', width: 120, columnSeparatorWidth: 1, type:'number',
            renderCell:(params) => (
                params.row.bidStatus === 9 ? '' : params.value
            ),
         },
        {
            field: 'entryUnit',
            headerName: '単位',
            width: 80,
            renderCell: (params) => (
              params.row.bidStatus === 9 ? '' : 
              <div>
                {bidUnitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'condition',  headerName: '入札条件', width: 300, columnSeparatorWidth: 1, },
    ]
    const bidUnitMapping = {
        1: '全量',
        2: 'Kg',
        3: 'D',
        4: '箱',
        5: '本',
        6: '匹',
        7: '袋',
    }
    //-----------------------------------------------
    // dataGrid - 水揚一覧の行の選択
    //-----------------------------------------------
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        if (event.row.entryUserId != userId) {
            setRequireMessage('入札情報の変更は同一ユーザのみ可能です')
            setMessageInfo('require', true)
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                seq           : '',
                tanka         : '',
                entrySuryo    : 0,
                entryUnit     : 1,
                conditionCode : '',
            }))
        } else {
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                seq           : event.row.seq,
                tanka         : event.row.tanka,
                entrySuryo    : event.row.entrySuryo,
                entryUnit     : event.row.entryUnit,
                conditionCode : event.row.conditionCode,
            }))
        }
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 概算の金額を算出する
	//-----------------------------------------------
    const handleClick_Register_before = () => {
        const noBid = bidHistoryList.some(item => item.bidStatus === 9);
        if (noBid){
            setRequireMessage('札入なしの入札情報は変更できません')
            setMessageInfo('require', true)
            return;
        }
        const requireStatus = checkedRequire() // 必須項目をチェックする
        if (requireStatus) {
            setRegisterMessage('')
            const entrySuryo   = Number(registerData.entrySuryo)
            const tanka        = Number(registerData.tanka)

            const kgDivision = bidGroupData.kgKubun == 1 ? 'Kg代' : '箱代'
            let suryo = ''
            if (registerData.entryUnit == '1') {
                suryo = '全量'
            } else if (registerData.entryUnit == '2') {
                suryo = `${entrySuryo}Kg`
            } else if (registerData.entryUnit == '3') {
                suryo = `${entrySuryo}Ⅾ`
            } else if (registerData.entryUnit == '4') {
                suryo = `${entrySuryo}箱`
            } else if (registerData.entryUnit == '5') {
                suryo = `${entrySuryo}本`
            } else if (registerData.entryUnit == '6') {
                suryo = `${entrySuryo}匹`
            } else if (registerData.entryUnit == '7') {
                suryo = `${entrySuryo}袋`
            }
            setRegisterMessage(
                <>
                <div style={{textAlign:'center'}}>
                    以下の内容で入札登録を行います。<br />
                    {kgDivision}<br />
                    単価：{tanka}円<br />
                    数量：{suryo}<br />
                    よろしいですか？
                </div>
                </>
            )
            // 単価が上限を超えていれば続けてコンファームを表示
            if (maxPrice && tanka >= maxPrice) {
                setMessageInfo('confirm_price_before', true)
            } else {
                setMessageInfo('confirm_register', true)
            }
        } else {
            setMessageInfo('require', true)
        }
    }
	//-----------------------------------------------
	// Function - 入札単価が上限を超えた場合のコンファーム表示
	//-----------------------------------------------
    const handleClick_Register_after = () => {
        setMessageInfo('confirm_price_before', false)
        setRegisterMessage('')
        const tanka = Number(registerData.tanka)
        setRegisterMessage(
            <>
            <div style={{fontWeight:'bold', textAlign:'center'}}>
                単価の入力に間違いないかご確認ください。<br />
                <span style={{color:'red', textDecoration:'underLine'}}>単価：{tanka}円</span><br />
                よろしいですか？
            </div>
            </>
        )
        setMessageInfo('confirm_price_after', true)
    }
	//-----------------------------------------------
	// Function - 入札の取り消しを行う
	//-----------------------------------------------
    const handleClick_Cancel_before = () => {

        setCancelMessage('')

        const tanka = Number(registerData.tanka)
        if (tanka) {
            setCancelMessage(
                <>
                  単価{tanka}円の入札を取り消します。<br />
                  よろしいですか？
                </>
            )
            setMessageInfo('confirm', true)
        } else {
            setRequireMessage('取り消しを行う入札情報を選択してください')
            setMessageInfo('require', true)
        }
    }
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const isState =
        bidHistoryList.length > 0 &&
        !bidHistoryList.some(
            item =>
            String(item.entryUserId) === String(registerData.entryUserId) &&
            item.seq === registerData.seq
        );

        if (isState) {
            setRequireMessage('入札登録は１件までの受付となります');
            return false;
        }
        const errorFields = [];
        if (!registerData.tanka) errorFields.push('「単価」')
        if (registerData.entrySuryo === '') {
            errorFields.push('「入札数量」')
        }
        if (!registerData.entryUnit) errorFields.push('「入札単位」')
        if (registerData.entryUnit == '0') errorFields.push('「入札単位」')
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません'
            setRequireMessage(text)
            return false
        }
        // 入札数量のチェック
        if (registerData.entryUnit != '1' && registerData.entrySuryo == 0) {
            setRequireMessage('入札数量が0になっています')
            return false;  // エラーがある場合は false を返します
        }
        // 単価の最大桁数のチェック
        //const num = parseInt(registerData.tanka, 10);
        //if (!isNaN(num) && num > 999999) {
        //    setRequireMessage('単価に999,999円以上は指定できません')
        //    return false;  // エラーがある場合は false を返します
        //}
        // 入札数量のチェック
        const entrySuryo = parseFloat(registerData.entrySuryo) // 数値として取得
        if (registerData.entryUnit == 2) {
            if ((entrySuryo != 0 || entrySuryo != 0.0) && entrySuryo < 10) {
                setRequireMessage('Kg指定時は「入札数量」を10Kg以上で入札してください')
                return false
            } 
            if (entrySuryo % 5 !== 0) {
                setRequireMessage('Kg指定時は「入札数量」を5Kg単位で入札してください')
                return false
            }
            if (bidGroupData.kgSuryo < entrySuryo) {
                setRequireMessage('「入札数量」が規定のKg数量を超過しています')
                return false
            } 
        }
        if (Number(registerData.entryUnit) > 3) {
            if (bidGroupData.suryo < entrySuryo) {
                setRequireMessage('「入札数量」が規定の数量を超過しています')
                return false
            }
        }
        
        return true  // エラーがない場合は true を返します
    }
    //-----------------------------------------------
	// Function - 残数再入札の判定(枝番があればtrue)
	//-----------------------------------------------
    const isRebid = () => {
        const num = Number(initialId)
        return !Number.isInteger(num);
    }
	//-----------------------------------------------
    // eventHandler - 開票解除ボタンのクリック
	//-----------------------------------------------
    const handleClick_fileName = (row) => {
        if (!row.fileName) return;
        setImagePreview({ url: row.fileName, title: row.bidName });
        setOpenDialogImageFile(true);
    };
	//-----------------------------------------------
    // eventHandler - 画像ビューアを表示
	//-----------------------------------------------
    const handleClick_dialog_imageFile = () => {
        setOpenDialogImageFile(true);
    };
	//-----------------------------------------------
    // eventHandler - 画像ビューアを非表示
	//-----------------------------------------------
    const handleClick_dialog_imageFile_close = () => {
        setOpenDialogImageFile(false);
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/bidGroup" setEntryDate={handleChange_entryDate} />
            <div className='bidRegister bodyContens'>
                <TitleBar title="入札登録" />
                <div style={{ display: 'flex', height: containerHeight }} className='mainContents'>
                    <div style={{ flex: 1, padding: '0px' }}>
                        <Frame classname="frame" title="入札情報">
                            <div style={{display:'flex'}}>
                                <div style={{marginLeft:'0px'}}>
                                    <ReaOnlyOutlinedInput 
                                        type     = "text" 
                                        id       = "bidRegister_bidGroupNo"
                                        label    = "入札No" 
                                        value    = { bidGroupData.entryNo }
                                        width    = "80px" 
                                    />
                                </div>
                                <div style={{marginLeft:'10px'}}>
                                    <CustomOutlinedInput
                                        type   = "text"
                                        id     = "bidManager_bidName"
                                        label  = "品名"
                                        value  = { bidGroupData.bidName }
                                        width = "250px"
                                    />
                                </div>
                                <div style={{marginLeft:'10px'}}>
                                    <CustomOutlinedInput
                                        type  = "text"
                                        id    = "bidManager_groupSuryo"
                                        label = "合計数量"
                                        value = {`${bidGroupData.kgSuryo}${unitName}`}
                                        width = "110px"
                                    />
                                </div>
                                <div style={{marginLeft:'10px'}}>
                                    <CustomOutlinedInput
                                        type   = "text"
                                        id     = "bidManager_kgKubun"
                                        label  = "販売単位"
                                        value={
                                            (() => {
                                                const division = [
                                                    { id: '0', name: '箱' },
                                                    { id: '1', name: 'Kg' },
                                                    { id: '2', name: '本' },
                                                    { id: '3', name: '匹' },
                                                    { id: '4', name: '袋' },
                                                ].find(item => String(item.id) === String(bidGroupData.kgKubun));
                                                return division ? division.name : '';
                                            })()
                                        }
                                        width = "100px"
                                    />
                                </div>
                                <div style={{marginLeft:'10px'}}>
                                    <CustomOutlinedInput
                                        type   = "text"
                                        id     = "bidManager_danbe"
                                        label  = "水槽No"
                                        value={ bidGroupData.danbe }
                                        width = "100px"
                                    />
                                </div>
                            </div>
                            <div style={{ flexGrow: 1, width: dataGridWidth, marginTop:'10px'}}>
                                <CustomDataGrid
                                    getRowClassName={(params) => {
                                        let className = ''
                                        if (params.indexRelativeToCurrentPage % 2 === 0) {
                                            className += 'even '
                                        } else {
                                            className += 'odd '
                                        }
                                        if ( bidGroupData.uniqueId && params.row.uniqueId !== bidGroupData.uniqueId) { //紐づけ魚種の行は赤文字で表示
                                            className += 'cell_red '
                                        }
                                        return className.trim() // クラス名の文字列の前後の余分な空白を削除
                                    }}
                                    editMode                = "row"
                                    rows                    = { bidList }
                                    columns                 = { columns }
                                    sx                      = { {height:'200px',fontSize:14,borderColor: 'primary.light',} }
                                    density                 = "compact"
                                    localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                    showColumnRightBorder
                                    showCellRightBorder
                                    disableColumnMenu       = {true}
                                    disableRowSelectionOnClick
                                    hideFooter
                                    loading                 = { getData_Loading }
                                />
                            </div>
                        </Frame>
                        <Frame classname="frame" title="入札登録状況">
                            <div style={{ flexGrow: 1, width: dataGridWidth, marginTop:'10px'}}>
                                <CustomDataGrid
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                    }
                                    editMode                = "row"
                                    disableSelectionOnClick = { true } 
                                    rows                    = { bidHistoryList }
                                    columns                 = { columns_history }
                                    sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                    density                 = "compact"
                                    localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                    showColumnRightBorder
                                    showCellRightBorder
                                    hideFooter
                                    disableColumnMenu          = {true}
                                    loading                    = { searchData_history_Loading }
                                    onCellClick             = {(event) => handleClick_dataGrid(event)}
                                />
                             </div>
                        </Frame>
                    </div>
                    <div style={{ width: '390px', padding: '0px'}}>
                        <div style={{backgroundColor:'#efefef', padding:'10px', height : contentsHeight}}>
                            <div style={{marginLeft:'0px', display:'flex', marginTop:'10px'}}>
                                <div style={{marginLeft:'0px'}}>
                                    <ReaOnlyOutlinedInput
                                        type     = "number"
                                        id       = "bidRegister_tanka"
                                        inputRef = { tankaRef } 
                                        label    = "単価" 
                                        value    = { registerData.tanka } 
                                        onClick  = {() => setFocusCell('tanka')} 
                                        onChange = {(e) => handleChange('tanka', e.target.value)}
                                        width    = "330px"
                                    />
                                </div>
                                <div style={{fontWeight:'bold', fontSize:'18px', padding:'5px'}}>円</div>
                            </div>
                            <div style={{marginLeft:'0px', display:'flex', marginTop:'10px'}}>
                                <div style={{marginLeft:'0px'}}>
                                    <ReaOnlyOutlinedInput 
                                        type     = "text" 
                                        id       = "bidRegister_entrySuryo" 
                                        inputRef = {entrySuryoRef} 
                                        label    = "入札数量" 
                                        value    = {registerData.entrySuryo} 
                                        onClick  = {() => setFocusCell('entrySuryo')} 
                                        onChange = {(e) => handleChange('entrySuryo', e.target.value)}
                                        width    = "260px" 
                                    />
                                </div>
                                <div style={{marginLeft:'10px'}}>
                                    <CustomSelect
                                        id         = "bidRegister_entryUnit"
                                        inputRef = {entryUnitRef} 
                                        label      = "単位"
                                        width      = "100px"
                                        dataList   = {bidUnitList} 
                                        selectedId = {registerData.entryUnit} 
                                        onChange   = {(e) => handleChange('entryUnit', e.target.value)} 
                                    />
                                </div>
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <div style={{ marginLeft : '0px', display : 'flex'}}>
                                    <div>
                                    <CustomSelect
                                        id         = "bidList_comment"
                                        inputRef   = {conditionRef} 
                                        label      = "入札条件"
                                        width      = "370px"
                                        dataList   = {commentList} 
                                        selectedId = {registerData.conditionCode}
                                        onChange   = {(e) => handleChange_comment(e.target.value)} 
                                    />
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginLeft : '0px', display : 'flex'}}>
                                <div style={{ width:'370px', paddingTop:'10px', marginLeft:'0px'}}>
                                    <div style={{display:'flex'}}>
                                        <div>
                                            <div style={{
                                                height: '264px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                            }}> 
                                                <Button
                                                    color   = "secondary"
                                                    size    = "large"
                                                    variant = "contained"
                                                    style   = {{ fontSize: '18px', height:'60px', width:'80px', color:'#fff'}}
                                                    onClick = {() => handleClick_noBid_before()}
                                                    >
                                                    {'札入なし'}
                                                </Button>
                                                <Button
                                                    color   = "primary"
                                                    size    = "large"
                                                    variant = "contained"
                                                    style   = {{ fontSize: '18px', height:'60px', width:'80px', color:'#fff'}}
                                                    onClick = {() => handleClick_new()}
                                                    >
                                                    {'新規'}
                                                </Button>
                                            </div>
                                        </div>
                                        <div style={{marginLeft:'5px'}}>
                                            <NumPad onKeyPress = { (e) => handleClick_numpad(e) } array={['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '00', 'C']} />
                                        </div>
                                    </div>
                                    <div style={{display:'flex', marginRight:'10px',marginTop:'5px'}}>
                                        <div style={{marginLeft:'0px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '18px', height:'70px', width:'80px', color:'#fff', backgroundColor:'#ff0000' }}
                                                onClick = {() => handleClick_Cancel_before()}
                                                >
                                                {'取消'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'95px', color:'#fff', backgroundColor:'#808080' }}
                                                onClick = {() => handleClick_numpad_enter()}
                                                >
                                                {'ENT'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'190px', color:'#fff', backgroundColor:'#4A9DBC' }}
                                                onClick = {() => handleClick_Register_before()}
                                                >
                                                {'登録'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dialog_fishMethodList'>
                    <Dialog open={ openDialogImageFile } onClose={ handleClick_dialog_imageFile } maxWidth="md" fullWidth>
                        <DialogTitle>
                            <TitleBar title="画像を確認" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box
                                component="img"
                                src={`${fileURL}${imagePreview.url}`}
                                alt={imagePreview.title}
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "70vh",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', margin: "0 auto", marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_imageFile_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = {cancelMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_register}
                    onClose   = {() => setMessageInfo('confirm_register', false)}
                    onClickNG = {() => setMessageInfo('confirm_register', false)}
                    onClickOK = {() => handleClick_Register('1')}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_price_before}
                    onClose   = {() => setMessageInfo('confirm_price_before', false)}
                    onClickNG = {() => setMessageInfo('confirm_price_before', false)}
                    onClickOK = {() => handleClick_Register_after()}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_price_after}
                    onClose   = {() => setMessageInfo('confirm_price_after', false)}
                    onClickNG = {() => setMessageInfo('confirm_price_after', false)}
                    onClickOK = {() => handleClick_Register('1')}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_noBid}
                    onClose   = {() => setMessageInfo('confirm_noBid', false)}
                    onClickNG = {() => setMessageInfo('confirm_noBid', false)}
                    onClickOK = {() => handleClick_noBid()}
                    message   = {noBidMessage}
                />
            </div>
        </>
    )
}
export default BidRegister

  
